import type { ReactNode } from 'react';

import { Card } from '@/components/layout/Card';

interface PageSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

/**
 * Generic page section with a title and card wrapper.
 * Useful for tables and forms to keep spacing consistent.
 */
export function PageSection({ title, children, className }: PageSectionProps) {
  return (
    <Card className={className ?? 'dashboard-listings-card p-[24px]'}>
      <h3 className="text-[#181818] text-[20px] font-semibold mb-[20px]">{title}</h3>
      {children}
    </Card>
  );
}
